import { Box, Container } from "@mui/material";

/**
 * Page-level padding + max-width wrapper. Use as the outer element of
 * every page body so spacing stays consistent.
 *
 * - `maxWidth` defaults to `xl` (1536px); pass `false` for fluid full-width.
 * - `dense` halves the vertical padding for pages that want more above-the-fold density.
 */
export default function PageContainer({
  children,
  maxWidth = "xl",
  dense = false,
  sx,
}) {
  return (
    <Box
      sx={{
        py: dense ? { xs: 2, sm: 3 } : { xs: 3, sm: 4 },
        px: { xs: 2, sm: 3 },
        ...sx,
      }}
    >
      <Container
        maxWidth={maxWidth}
        disableGutters
        sx={{ minWidth: 0 }}
      >
        {children}
      </Container>
    </Box>
  );
}
